import { MenuItem, Select, SxProps, Typography, useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Option } from 'common/types';
import { Loading } from 'components/Loading';

const menuItemContainer = (primaryColor: string): SxProps => ({
  ':hover': {
    backgroundColor: primaryColor
  },
  '&.Mui-selected': {
    ':hover': {
      backgroundColor: primaryColor
    },
    backgroundColor: primaryColor
  },
  px: 2,
  py: 1
});

type Props = {
  value?: string;
  onChange: (value: string) => void;
  options: Option[];
  showValueChosenIcon?: boolean;
  placeholder: string;
  isLoading?: boolean;
};

/**
 * @deprecated use dropdown from 'common/form'
 */
export const DropDown: React.FC<Props> = ({
  value,
  onChange,
  options,
  showValueChosenIcon,
  placeholder,
  isLoading = false
}) => {
  const { palette } = useTheme();

  return (
    <Select
      variant="outlined"
      value={value || ''}
      fullWidth
      displayEmpty
      renderValue={(selectedValue) => {
        const selectedOption = options.find(
          (option) => option.value === selectedValue
        );

        if (!selectedOption) {
          return <Typography variant="body2">{placeholder}</Typography>;
        }

        return <Typography variant="body2">{selectedOption.label}</Typography>;
      }}
      disabled={isLoading}
      IconComponent={
        isLoading
          ? () => <Loading sx={{ mr: 1 }} size={20} />
          : KeyboardArrowDownIcon
      }
      onChange={(e) => {
        if (!e.target.value) return;
        onChange(e.target.value as string);
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: '8px'
          }
        }
      }}
    >
      {options.map((option) => {
        return (
          <MenuItem
            sx={menuItemContainer(palette.customGrey.light)}
            key={option.value}
            value={option.value}
          >
            {value === option.value && showValueChosenIcon && (
              <CheckIcon color="primary" sx={{ mr: 1 }} />
            )}
            <Typography variant="body2">{option.label}</Typography>
          </MenuItem>
        );
      })}
    </Select>
  );
};
